import { formatDate } from "../../../../utils/Utils";
import { typeFormatter } from "../../../../utils/tableDataFormatter";
import { HEADER_STYLE, DATA_STYLE } from "../excelReportStyles";
import {
  parseJSON,
  formatPlantTrainName,
  addBordersToSheet,
  formatReasonWithProportion,
} from "../excelReportUtils";

export const createBenchmarkFoulingTypeSheet = (sheet, plants, t) => {
  const allFoulingData = [];

  plants.forEach((plant) => {
    const parsePlantFouling = (foulingData, trainNum, plantId, plantName) => {
      const cipData = foulingData.cip || {};
      const primaryReasons = foulingData.primary_reason || {};
      const secondaryReasons = foulingData.secondary_reason || {};

      Object.keys(cipData).forEach((cipKey) => {
        const cip = cipData[cipKey];
        if (!(cip && cip.sd && cip.ed)) {
          return;
        }

        allFoulingData.push({
          plant_id: plantId,
          plant_name: plantName || "Plant",
          train_num: trainNum,
          type: typeFormatter({ value: cip.type }, t) || "CIP",
          start_date: cip.sd,
          end_date: cip.ed,
          primary_reason: primaryReasons[cipKey] || "-",
          primary_proportion: foulingData.proportion1?.[cipKey] ?? null,
          secondary_reason: secondaryReasons[cipKey] || "-",
          secondary_proportion: foulingData.proportion2?.[cipKey] ?? null,
        });
      });
    };

    if (plant?.trains && Array.isArray(plant.trains)) {
      plant.trains.forEach((train) => {
        parsePlantFouling(
          parseJSON(train.fouling_data),
          train.train_num,
          plant.plant_id,
          plant.plant_name,
        );
      });
    } else if (plant?.fouling_data) {
      const foulingData = parseJSON(plant.fouling_data);
      if (foulingData && Object.keys(foulingData).length > 0) {
        parsePlantFouling(
          foulingData,
          plant.train_num,
          plant.plant_id,
          plant.plant_name,
        );
      }
    }
  });

  const headers = [
    t("benchMark.headers.plantName"),
    t("benchMark.headers.type"),
    t("benchMark.headers.startDate"),
    t("benchMark.headers.endDate"),
    t("benchMark.headers.primaryReason"),
    t("benchMark.headers.secondaryReason"),
  ];

  const headerRow = sheet.getRow(1);
  headers.forEach((header, idx) => {
    const cell = headerRow.getCell(idx + 1);
    cell.value = header;
    Object.assign(cell, HEADER_STYLE);
  });
  headerRow.commit();

  allFoulingData.forEach((data, idx) => {
    const row = sheet.getRow(2 + idx);
    const values = [
      formatPlantTrainName(data.plant_name, data.plant_id, data.train_num),
      data.type || "-",
      data.start_date ? formatDate(data.start_date) : "-",
      data.end_date ? formatDate(data.end_date) : "-",
      formatReasonWithProportion(data.primary_reason, data.primary_proportion) ||
        "-",
      formatReasonWithProportion(data.secondary_reason, data.secondary_proportion) ||
        "-",
    ];

    values.forEach((value, valueIdx) => {
      const cell = row.getCell(valueIdx + 1);
      cell.value = value;
      Object.assign(cell, DATA_STYLE);
    });

    row.commit();
  });

  sheet.getColumn(1).width = 35;
  sheet.getColumn(2).width = 12;
  sheet.getColumn(3).width = 12;
  sheet.getColumn(4).width = 12;
  sheet.getColumn(5).width = 25;
  sheet.getColumn(6).width = 25;

  addBordersToSheet(sheet);
};
